// firebase.service.ts
import { Injectable } from '@angular/core';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { Auth, GoogleAuthProvider, confirmPasswordReset, getAuth, sendPasswordResetEmail, signInWithPopup } from 'firebase/auth';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  app: FirebaseApp;
  auth: Auth;

  setupFirebase() {
    this.app = initializeApp(environment.firebaseConfig);
    this.auth = getAuth(this.app);
  }

  async googleLogin(): Promise<string> {
    const googleProvider = new GoogleAuthProvider();
    const userCredential = await signInWithPopup(this.auth, googleProvider);
    return userCredential.user.uid;
  }

  async resetPassword(email: string): Promise<void> {
    console.log("Sending reset email to: ", email);
    return await sendPasswordResetEmail(this.auth, email, {
      url: environment.suiteUrl + "/sign-in",
      handleCodeInApp: false
    });
  }

  async performResetPassword(code: string, password: string): Promise<void> {
    return await confirmPasswordReset(this.auth, code, password)
  }

  // async login(email: string, password: string): Promise<string | null> {
  //   //const auth = getAuth(this.app);
  //   return await signInWithEmailAndPassword(this.auth, email, password)
  //   .then((userCredential) => {
  //     this._completeLogin(userCredential);
  //     return null;
  //       // console.log("User: ", userCredential);

  //       // const user = userCredential.user;
  //       // const userData = {
  //       //     uid: user.uid,
  //       //     email: user.email,
  //       //     displayName: user.displayName
  //       // };
  //       // document.cookie = `user=${JSON.stringify(userData)}; HttpOnly; Secure; SameSite=Lax`;
  //       // return null;
  //   })
  //   .catch((error) => {
  //       console.error("Error logging in: ", error);
  //       return error.message;
  //   }); 
  // }
 
  // private _completeLogin(userCredential: UserCredential) {
  //   console.log("User: ", userCredential);

  //   const user = userCredential.user;
  //   const userData = {
  //       uid: user.uid,
  //       email: user.email,
  //       displayName: user.displayName
  //   };
  //   document.cookie = `user=${JSON.stringify(userData)}; HttpOnly; Secure; SameSite=Lax`;
  //   return null;
  // }
}